import { capitalize } from 'es-toolkit/compat';
import { getLanguageDisplayFromLanguage } from 'features/campaign/campaign.util';
import type { GetPlacementDisplayName } from '../../campaign-configs/types/summary-section.types';

export const getPlacementDisplayNameNoPlatform: GetPlacementDisplayName = ({ language, marketplace }) => {
  const displayLanguage = getLanguageDisplayFromLanguage(language);
  return `${marketplace} ${displayLanguage}`;
};

export const getPlacementDisplayNameWithPlatform: GetPlacementDisplayName = ({
  language,
  platform,
  marketplace,
  platformNameOverrides,
}) => {
  const displayLanguage = getLanguageDisplayFromLanguage(language);
  const displayPlatform = platformNameOverrides?.[platform!] ?? capitalize(platform!);
  return `${marketplace} ${displayLanguage} ${displayPlatform}`;
};
